// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2B83C","header":"ReportDetails_header__1jsah","title":"ReportDetails_title__2vl9R","left":"ReportDetails_left__1PYSk"};